import { render, staticRenderFns } from "./menu-doing.vue?vue&type=template&id=5566c6a4&"
import script from "./menu-doing.vue?vue&type=script&lang=js&"
export * from "./menu-doing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports